//relies on translations, language variable from PouchService
import { Pipe, PipeTransform } from '@angular/core';
import { PouchService } from '../services/pouch-service';
@Pipe({
  name: 'Translate',
})
export class Translation implements PipeTransform {
  constructor(public db: PouchService) {
  }
  transform(name, language = 'en', type = 'input', item = null) {
    return (this.db.rename(name, language, type, item));
  }

  titleCase(text) {
    return text.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
  };
}
